// src/components/Spacer.tsx
import { isNumber } from "@teamsparta/utils";
import {
  forwardRef
} from "react";
import { jsx } from "react/jsx-runtime";
var Spacer = forwardRef(function SpacerComponent({
  as,
  orientation = "vertical",
  size = "1rem",
  style,
  ...props
}, ref) {
  const Component = as || "div";
  const coercedSize = isNumber(size) ? `${size}px` : size;
  const _style = orientation === "vertical" ? { height: coercedSize, minHeight: coercedSize } : { width: coercedSize, minWidth: coercedSize };
  return /* @__PURE__ */ jsx(Component, { ref, style: { ..._style, ...style }, ...props });
});

export {
  Spacer
};
